module.exports = __webpack_public_path__ + "media/images/players/SCHWARTZEL_CHARL-b8f2ffb7b2344688b7b80b6586375d33.png";